import React from 'react';
import { Div, Icon, Flex, Link } from 'ui';
import styled, { css } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { isObjectNullOrEmpty } from '../../utils/helpers';
import { announcementBannerHeight } from '../../utils/app-configs';
import {
  openAnnouncementsSidepanel,
} from '../../settings/containers/announcements/announcements-actions';

const Wrapper = styled(Div)`
  height: ${announcementBannerHeight}px;
  position: sticky;
  z-index: 120;
  top: 55px;
  background-color: white;

  ${p => p.isFullScreen && css`
    position: fixed;
    width: 100vw;
    top: 0;
    left: 0;
  `}

  .severity-informational {
    background-color: ${p => p.theme.colors.alerts[3]}40;
    border: ${p => p.theme.colors.alerts[3]} solid 2px;
  }

  .severity-moderate {
    background-color: ${p => p.theme.colors.alerts[2]}40;
    border: ${p => p.theme.colors.alerts[2]} solid 2px;
  }

  .severity-high {
    background-color: ${p => p.theme.colors.alerts[1]}40;
    border: ${p => p.theme.colors.alerts[1]} solid 2px;
  }
`;

const StyledFlex = styled(Flex)`
  height: 100%;
  gap: 5px;
`;

const StyledIcon = styled(Icon)`
    ${p => p.severity === 'informational' && css`
        color: ${p.theme.colors.alerts[3]} !important;
    `}

    ${p => p.severity === 'moderate' && css`
        color: ${p.theme.colors.alerts[2]} !important;
    `}

    ${p => p.severity === 'high' && css`
        color: ${p.theme.colors.alerts[1]} !important;
    `}
`;

const StyledLink = styled(Link)`
  font-size: 12px;
  text-decoration: underline;
`;

const Banner = ({
  intl,
  isFullScreen,
  setFullScreen,
}) => {
  const { bannerAnnouncement } = useSelector(state => state.user);
  const dispatch = useDispatch();

  const handleOpenSidepanel = () => {
    if (isFullScreen && setFullScreen) {
      setFullScreen(false);
    }
    dispatch(openAnnouncementsSidepanel({ filterOnId: bannerAnnouncement?.id }));
  };

  return !isObjectNullOrEmpty(bannerAnnouncement) &&
    <Wrapper severity={bannerAnnouncement?.severity?.id} isFullScreen={isFullScreen}>
      <StyledFlex aic jcc className={`severity-${bannerAnnouncement?.severity?.id}`}>
        <StyledIcon
          type={bannerAnnouncement?.severity?.icon}
          severity={bannerAnnouncement?.severity?.id}
        />
        {bannerAnnouncement?.title}
        <StyledLink onClick={handleOpenSidepanel}>
          {intl.formatMessage({ id: 'common.LEARN_MORE' })}
        </StyledLink>
      </StyledFlex>
    </Wrapper>;
};

Banner.propTypes = {
  intl: PropTypes.object,
  isFullScreen: PropTypes.bool,
  setFullScreen: PropTypes.func,
};

export default injectIntl(Banner);
